import { render, staticRenderFns } from "./shopQrCodePayRecord.vue?vue&type=template&id=520612b1&scoped=true"
import script from "./shopQrCodePayRecord.vue?vue&type=script&lang=js"
export * from "./shopQrCodePayRecord.vue?vue&type=script&lang=js"
import style0 from "./shopQrCodePayRecord.vue?vue&type=style&index=0&id=520612b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520612b1",
  null
  
)

export default component.exports